import { ReactNode } from "react";

import { Layout } from "react-grid-layout";
import { IntlShape } from "react-intl";

import GoalType from "@app/enum/dashboard/GoalType";
import CardContentComponent from "@app/scene/dashboard/components/cards/UpcomingActivities/CardContentComponent";
import CardUi from "@app/scene/dashboard/types/CardUiDescriptor";
import UpcomingActivitiesCardConfiguration from "@app/types/dashboard/cards/upcomingActivities/UpcomingActivitiesCardConfiguration";
import UpcomingActivitiesViewState from "@app/types/dashboard/cards/upcomingActivities/UpcomingActivitiesViewState";

import { GRID_WIDTH } from "../../DashboardContent/util/consts";
import DefaultNextTimeRangeFormComponent from "../common/DefaultNextTimeRangeFormComponent";
import GoalDetailsFormComponent from "../common/GoalDetailsFormComponent";

import CriteriaFormComponent from "./CriteriaFormComponent";
import messages from "./messages";
import PreferencesFormComponent from "./PreferencesFormComponent";

const upcomingActivitiesCard: CardUi<UpcomingActivitiesCardConfiguration> = {
  CardContentComponent,
  CriteriaFormComponent,
  DateRangeFormComponent: DefaultNextTimeRangeFormComponent,
  getCardDimensions({ viewState }): Pick<Layout, "h" | "w"> {
    const dimensions = {
      h: 4,
      w: (viewState as UpcomingActivitiesViewState).fullWidth ? GRID_WIDTH : 4,
    };
    return dimensions;
  },
  getCardPlainTitle(intl, context): string {
    const dateRange = context.configuration.dateRange;
    return intl.formatMessage(messages.cardTitle, {
      date: (text: string[]) => text,
      dateRange: dateRange.range,
      dateSubRange: dateRange.subRange,
    }) as string;
  },
  getGoalDescription(): ReactNode {
    return null;
  },
  getGoalType() {
    return { format: "amount", goalType: GoalType.NO_GOAL };
  },
  getModalTitle(intl: IntlShape): ReactNode {
    return intl.formatMessage(messages.modalTitle);
  },
  GoalDetailsComponent: GoalDetailsFormComponent,
  PreferencesFormComponent,
};

export default upcomingActivitiesCard;
